import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFourthScreen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_2568_117300",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 2.5,
				y: 2.5,
				width: 15,
				height: 15,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2.5,
			y: 2.5,
			width: 15,
			height: 15,
			rx: 1,
			fill: "#636C7B",
			stroke: "#636C7B",
			strokeWidth: 3,
			mask: "url(#path-1-inside-1_2568_117300)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.75,
			y: 3.75,
			width: 6.25,
			height: 6.25,
			rx: 1,
			fill: "white"
		})
	]
});
export default SvgFourthScreen;
